const SHINE_KEYFRAMES = `
@keyframes uk-shine-sweep {
  0%   { transform: translateX(-120%) skewX(-18deg); opacity: 0; }
  20%  { opacity: 0.55; }
  60%  { opacity: 0.55; }
  100% { transform: translateX(220%) skewX(-18deg); opacity: 0; }
}
@keyframes uk-shine-glow {
  0%, 100% { opacity: 0.35; }
  50%      { opacity: 0.75; }
}
`;

export const ShineEffect = ({
  className = "",
  duration = 6,
  color = "rgba(255, 255, 255, 0.55)",
  darkColor = "rgba(251, 146, 60, 0.18)",
}) => {
  return (
    <>
      <style>{SHINE_KEYFRAMES}</style>
      <div
        aria-hidden="true"
        className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
      >
        <div
          className="absolute inset-y-0 -left-1/3 w-1/3"
          style={{
            background: `linear-gradient(90deg, transparent 0%, ${color} 45%, ${color} 55%, transparent 100%)`,
            animation: `uk-shine-sweep ${duration}s linear infinite`,
            mixBlendMode: "overlay",
            filter: "blur(2px)",
          }}
        />
        <div
          className="absolute inset-y-0 -left-1/3 w-1/4 dark:block hidden"
          style={{
            background: `linear-gradient(90deg, transparent 0%, ${darkColor} 50%, transparent 100%)`,
            animation: `uk-shine-sweep ${duration * 1.4}s linear infinite`,
            animationDelay: `${duration / 2}s`,
            filter: "blur(6px)",
          }}
        />
      </div>
    </>
  );
};

export const GlowOrb = ({
  className = "",
  size = 320,
  color = "rgba(251, 146, 60, 0.25)",
  duration = 8,
}) => {
  return (
    <>
      <style>{SHINE_KEYFRAMES}</style>
      <div
        aria-hidden="true"
        className={`pointer-events-none absolute rounded-full blur-3xl ${className}`}
        style={{
          width: size,
          height: size,
          background: `radial-gradient(circle, ${color} 0%, transparent 70%)`,
          animation: `uk-shine-glow ${duration}s ease-in-out infinite`,
        }}
      />
    </>
  );
};
